<!-- 对账单申请 -->
<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <!-- start of title -->
    <div class="title-box">
      <el-button type="default" size="mini" @click="$router.go(-1)"
        >返回</el-button
      >
      <span>对账单申请</span>
    </div>
    <!-- end of title -->

    <!-- start of form -->
    <div class="form-box">
      <!-- start of 对账单申请信息 -->
      <div class="back-color-fff mt-4">
        <span class="form-title">对账单申请信息</span>

        <el-form :model="formData" ref="formData">
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label-width="145px">
                <span slot="label">
                  <span style="color: red">*</span>上游服务商：
                </span>
                <el-select
                  v-model="formData.serviceTenantGuid"
                  placeholder="请选择企业"
                  @change="tenantChange"
                  filterable
                >
                  <el-option
                    v-for="item in serviceTenantList"
                    :key="item.sendTenantGuid"
                    :label="item.sendTenantName"
                    :value="item.sendTenantGuid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label-width="145px">
                <span slot="label">
                  <span style="color: red">*</span>对账日期：
                </span>
                <el-date-picker
                  v-model="formData.settleDate"
                  type="date"
                  placeholder="选择对账日期"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label-width="145px">
                <span slot="label">
                  <span style="color: red">*</span>申请盖章：
                </span>
                <el-select
                  filterable
                  clearable
                  v-model="formData.isStampApply"
                  placeholder="请选择申请盖章"
                >
                  <el-option label="是" value="Y"></el-option>
                  <el-option label="否" value="N"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="accountMonth" label-width="145px">
                <span slot="label">
                  <span style="color: red">*</span>核算月：
                </span>
                <el-date-picker
                  v-model="formData.accountMonth"
                  value-format="yyyy-MM"
                  type="month"
                  placeholder="请选择核算月"
                  @change="changeAccountMonth"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label-width="145px">
                <span slot="label" style="color: red">*</span>
                <span slot="label">任务包选择：</span>
                <el-select
                  v-model="formData.isSelectTask"
                  placeholder="请选择"
                  filterable
                  @change="changePrecise"
                >
                  <el-option
                    v-for="item in isOption"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-show="formData.isSelectTask == 'N'">
              <el-form-item label-width="145px">
                <span slot="label" style="color: red">*</span>
                <span slot="label">接包组织名称：</span>
                <el-select
                  collapse-tags
                  v-model="formData.organisationGuid"
                  @change="changeDataOrganisation"
                  placeholder="请选择"
                  filterable
                >
                  <el-option
                    v-for="item in organisationDataList"
                    :key="item.guid"
                    :label="item.organisationName"
                    :value="item.guid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-show="formData.isSelectTask == 'Y'">
              <el-form-item label-width="145px">
                <span slot="label" style="color: red">*</span>
                <span slot="label">任务包标题：</span>
                <el-select
                  collapse-tags
                  v-model="formData.taskGuidList"
                  placeholder="请选择"
                  filterable
                  multiple
                  @change="changeTaskGuidList"
                  class="select-with-search"
                >
                  <el-option
                    v-for="item in taskList"
                    :key="item.guid"
                    :label="item.taskTitleOrganisation"
                    :value="item.guid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label-width="145px">
                <span slot="label" style="color: red"> </span>
                <span slot="label">账单周期：</span>
                <el-select
                  collapse-tags
                  v-model="formData.billCycleList"
                  placeholder="请选择"
                  multiple
                  filterable
                >
                  <el-option
                    v-for="item in billCycleListArr"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label-width="145px">
                <span slot="label" style="color: red">*</span>
                <span slot="label">选择合同：</span>
                <el-select
                  v-model="formData.contractGuid"
                  placeholder="请选择"
                  filterable
                >
                  <el-option
                    v-for="item in contractList"
                    :key="item.guid"
                    :label="item.text"
                    :value="item.guid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label-width="145px">
                <span slot="label" style="color: red">*</span>
                <span slot="label">合格状态：</span>
                <el-select
                  collapse-tags
                  filterable
                  multiple
                  v-model="formData.qualityStateList"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in getCodeListByKey('合格状态')"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label-width="145px">
                <span slot="label" style="color: red">*</span>
                <span slot="label">是否展示服务费：</span>
                <el-select
                  filterable
                  v-model="formData.isShowServiceFee"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in trueOrFalseOption"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label-width="145px">
                <span slot="label"> 关联金额对冲流程： </span>
                <el-input
                  v-model="formData.relevanceHedge"
                  placeholder="请选择关联金额对冲流程"
                  readonly
                  @focus="showHedgeList"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="16">
              <el-form-item label-width="145px">
                <span slot="label" style="color: red"> </span>
                <span slot="label">备注说明：</span>
                <el-input
                  type="textarea"
                  :rows="5"
                  :maxlength="200"
                  placeholder="最多可输入200个字"
                  v-model="formData.memo"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div
          style="padding-top: 20px; margin-left: 100px; padding-bottom: 20px"
        >
          <el-button size="mini" type="info" @click="searchData"
            >搜索</el-button
          >
          <el-button size="mini" type="danger" @click="empty">清空</el-button>
        </div>
      </div>
      <!-- end of 对账单信息 -->

      <!-- start of 单据明细 -->
      <div class="back-color-fff mt-4 pd-16">
        <span class="form-title">单据明细</span>
        <div class="content-main-box detail-box">
          <div class="flex-between" v-if="tableData?.length">
            <div class="button-area" style="margin-top: -8px">
              <el-button size="mini" type="info" @click="batchEditTime()"
                >批量修改对账日期</el-button
              >
              <el-button size="mini" type="info" @click="getOrganisation()"
                >批量删除</el-button
              >
            </div>
            <p class="total-tip">
              结算金额合计：<span>{{
                getSumAmount(tableData, 1) | numDigit
              }}</span
              >元&nbsp;&nbsp;&nbsp;应发金额合计：<span>{{
                getSumAmount(tableData, 2) | numDigit
              }}</span>
              元&nbsp;&nbsp;&nbsp;实发金额合计：<span>{{
                getSumAmount(tableData, 3) | numDigit
              }}</span>
              元
            </p>
          </div>
          <el-table
            stripe
            border
            ref="multipleTable"
            max-height="352px"
            :data="tableData"
            :row-key="(row) => row.rowKey"
            @selection-change="handleSelectionChange"
          >
            <!-- selection -->
            <el-table-column
              type="selection"
              width="60"
              header-align="center"
              align="center"
            ></el-table-column>
            <!-- 序号 -->
            <el-table-column
              label="序号"
              width="60"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <span :style="scope.row.unPayMoney != 0 ? 'color:red' : ''">{{
                  scope.$index + 1
                }}</span>
              </template>
            </el-table-column>
            <!-- 姓名 -->
            <el-table-column
              width="96"
              prop="staffName"
              label="姓名"
              header-align="center"
              align="left"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span :style="scope.row.unPayMoney != 0 ? 'color:red' : ''">{{
                  scope.row.staffName || "-"
                }}</span>
              </template>
            </el-table-column>
            <!-- 身份证号 -->
            <!-- <el-table-column
              prop="idCode"
              label="身份证号"
              header-align="center"
              align="left"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span :style="scope.row.unPayMoney != 0 ? 'color:red' : ''">{{
                  scope.row.idCode || "-"
                }}</span>
              </template>
            </el-table-column> -->
            <!-- 银行卡号 -->
            <el-table-column
              prop="bankAccount"
              label="银行卡号"
              header-align="center"
              align="left"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span :style="scope.row.unPayMoney != 0 ? 'color:red' : ''">{{
                  scope.row.bankAccount || "-"
                }}</span>
              </template>
            </el-table-column>
            <!-- 手机号 -->
            <el-table-column
              prop="mobileNo"
              label="手机号"
              header-align="center"
              align="left"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span :style="scope.row.unPayMoney != 0 ? 'color:red' : ''">{{
                  scope.row.mobileNo || "-"
                }}</span>
              </template>
            </el-table-column>
            <!-- 任务内容 -->
            <el-table-column
              prop="taskContent"
              label="任务内容"
              header-align="center"
              align="left"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span :style="scope.row.unPayMoney != 0 ? 'color:red' : ''">
                  {{ scope.row.taskContent || "-" }}</span
                >
              </template>
            </el-table-column>
            <!-- 结算金额 -->
            <el-table-column
              prop="settleAmount"
              width="100"
              label="结算金额(元)"
              header-align="center"
              align="right"
            >
              <template slot-scope="scope"
                ><span :style="scope.row.unPayMoney != 0 ? 'color:red' : ''">{{
                  scope.row.settleAmount | numFmt | numDigit
                }}</span></template
              >
            </el-table-column>
            <!-- 本月累计下发金额 -->
            <el-table-column
              prop="currentMonthMoneySum"
              width="140"
              label="本月累计下发金额(元)"
              header-align="center"
              align="right"
              show-overflow-tooltip
            >
              <template slot-scope="scope"
                ><span :style="scope.row.unPayMoney != 0 ? 'color:red' : ''">{{
                  scope.row.currentMonthMoneySum | numFmt | numDigit
                }}</span></template
              >
            </el-table-column>
            <!-- 已发金额（新加） -->
            <el-table-column
              prop="lastMonthMoney"
              min-width="96"
              label=" 已发金额(元)"
              header-align="center"
              align="right"
              show-overflow-tooltip
            >
              <template slot-scope="scope"
                ><span :style="scope.row.unPayMoney != 0 ? 'color:red' : ''">{{
                  scope.row.paidMoney | numFmt | numDigit
                }}</span></template
              >
            </el-table-column>
            <!-- 未发金额 -->
            <el-table-column
              prop="lastMonthMoney"
              min-width="96"
              label="未发金额(元)"
              header-align="center"
              align="right"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span :style="scope.row.unPayMoney != 0 ? 'color:red' : ''">
                  {{ scope.row.unPayMoney | numFmt | numDigit }}</span
                >
              </template>
            </el-table-column>
            <!-- 应发金额（新加） -->
            <el-table-column
              prop="lastMonthMoney"
              min-width="96"
              label="应发金额(元)"
              header-align="center"
              align="right"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span :style="scope.row.unPayMoney != 0 ? 'color:red' : ''">
                  {{ scope.row.realSettleMoney | numFmt | numDigit }}</span
                ></template
              >
            </el-table-column>
            <!-- 实发金额（新加） -->
            <el-table-column
              prop="lastMonthMoney"
              width="150"
              label="实发金额(元)"
              header-align="center"
              align="right"
            >
              <template slot-scope="scope">
                <!-- <span :style="scope.row.unPayMoney != 0 ? 'color:red' : ''"> {{scope.row.realSettleMoney | numFmt | numDigit }} </span>-->
                <!-- <el-input-number size="mini"  :precision="2" :controls="false" placeholder="请输入" v-model.trim="scope.row.realSettleMoney">
                                </el-input-number> -->
                <div style="display: flex">
                  <!-- <el-input size="mini" type="input" :maxlength="30" placeholder="请输入" v-model.trim="scope.row.realSettleMoney">
                                </el-input> -->
                  <el-input-number
                    size="mini"
                    :min="0"
                    :max="scope.row.realSettleMoney"
                    :precision="2"
                    :controls="false"
                    placeholder="请输入"
                    v-model.trim="scope.row.actualSettleMoney"
                  >
                  </el-input-number>
                </div>
              </template>
            </el-table-column>

            <!-- 对账单日期 -->
            <el-table-column
              prop="settleDate"
              label="对账日期"
              header-align="center"
              align="right"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span>{{ scope.row.settleDate | getDate }}</span>
              </template>
            </el-table-column>

            <!-- 供应商 -->
            <!-- <el-table-column
              prop="levyCompanyName"
              label="供应商"
              header-align="center"
              align="right"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span :style="scope.row.unPayMoney != 0 ? 'color:red' : ''">{{
                  scope.row.levyCompanyName
                }}</span>
              </template>
            </el-table-column> -->
            <!-- 备注(含本次下发) -->
            <!-- <el-table-column prop="memo" min-width="96" label="备注(含本次下发)" header-align="center" show-overflow-tooltip>
                        </el-table-column> -->
            <el-table-column
              label="操作"
              header-align="center"
              width="60"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <a class="txt-color" @click="delItem(scope.row, scope.$index)"
                  >删除</a
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- end of 单据明细 -->

      <!-- start of 收款方明细信息 -->
      <div class="back-color-fff mt-4 pd-16">
        <span class="form-title">我方银行账号信息</span>
        <div class="content-main-box detail-box">
          <el-table
            stripe
            border
            ref="multipleTable3"
            row-key="bankAccount"
            :data="settleReceiveBankInfo"
          >
            <el-table-column type="expand" width="20">
              <template slot-scope="props">
                <el-form label-position="left" inline class="table-expand">
                  <el-form-item label="备注">
                    <el-input
                      size="mini"
                      v-model="props.row.memo"
                      placeholder="请输入备注"
                    ></el-input>
                  </el-form-item>
                </el-form>
              </template>
            </el-table-column>
            <!-- 开户名称 -->
            <el-table-column
              show-overflow-tooltip
              label="开户名称"
              width="210"
              header-align="center"
              align="left"
            >
              <template slot-scope="scope">
                {{ scope.row.tenantName || "-" }}
              </template>
            </el-table-column>
            <!-- 开户银行 -->
            <el-table-column
              label="开户银行"
              width="220"
              header-align="center"
              align="left"
            >
              <template slot-scope="scope">
                <div style="padding: 4px 0">
                  <el-select
                    style="width: 200px"
                    size="mini"
                    @change="bankReciveChange(scope)"
                    filterable
                    clearable
                    v-model="scope.row.bankGuid"
                    placeholder="请选择开户银行"
                  >
                    <el-option
                      v-for="item in scope.row.bankList"
                      :key="item.guid"
                      :label="item.bankName"
                      :value="item.guid"
                    >
                      <span style="float: left">{{
                        `${item.bankName}_${item.bankAccount}_${$getNameByKey(
                          item.accountType,
                          "账户类型"
                        )}`
                      }}</span>
                    </el-option>
                  </el-select>
                </div>
              </template>
            </el-table-column>
            <!-- 银行账户 -->
            <el-table-column
              show-overflow-tooltip
              label="银行账户"
              width="220"
              header-align="center"
              align="left"
            >
              <template slot-scope="scope">
                {{ scope.row.bankAccount || "-" }}
              </template>
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="税号"
              width="180"
              header-align="center"
              align="left"
            >
              <template slot-scope="scope">
                {{ scope.row.taxNo || "-" }}
              </template>
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="电话"
              width="110"
              header-align="center"
              align="left"
            >
              <template slot-scope="scope">
                {{ scope.row.tel || "-" }}
              </template>
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="付款地址"
              header-align="center"
              align="left"
            >
              <template slot-scope="scope">
                {{ scope.row.address || "-" }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- end of 收款方明细信息 -->

      <!-- start of 流程审批 -->
      <div class="back-color-fff mt-4 pd-16">
        <!-- <span class="form-title">流程审批</span> -->
        <div class="flow">
          <iframe
            scrolling="no"
            v-show="iframeSh"
            :src="iframeSrc"
            class="iframe-sty"
          ></iframe>
        </div>
      </div>
      <!-- end of 流程审批 -->

      <!-- start of bottom-btn -->
      <div class="back-color-fff submit_btn_wrap">
        <el-button
          type="defalut"
          class="cannel-btn"
          size="mini"
          @click="$router.go(-1)"
          >取消</el-button
        >
        <el-button type="defalut" size="mini" @click="submitForm"
          >保存</el-button
        >
        <!-- <el-button type="primary" size="mini" @click="submitForm(true)">提交申请</el-button> -->
      </div>
      <!-- end of bottom-btn -->
    </div>
    <!-- end of form -->

    <!-- start of dialog-关联金额对冲流程 -->
    <el-dialog
      title="金额对冲"
      class="flow-dialog"
      :visible.sync="dialogHedgeVisible"
      width="80%"
    >
      <div class="content-main-box content-main-box2">
        <div class="search-area">
          <el-row :gutter="24">
            <el-col :span="8">
              <div class="search-area-div w80">关键字搜索</div>
              <el-input
                v-model="pageHedge.searchKey"
                placeholder="请输入企业、组织、应付金额搜索"
                size="mini"
                class="ipt-sty"
              >
              </el-input>
            </el-col>
            <!-- <el-col :span="8">
                            <div class="search-area-div w60">关联状态</div>
                            <el-select filterable clearable v-model="pageHedge.isSettleUsed" placeholder="请选择关联状态"
                                size="mini" class="ipt-sty">
                                <el-option label="全部" value=""></el-option>
                                <el-option label="已关联" value="Y"></el-option>
                                <el-option label="未关联" value="N"></el-option>
                            </el-select>
                        </el-col> -->
            <el-col :span="8" class="search-btn-box">
              <el-button size="mini" type="info" @click="getHedgeList()"
                >搜索</el-button
              >
              <el-button size="mini" type="danger" @click="emptyHedge"
                >清空</el-button
              >
            </el-col>
          </el-row>
        </div>

        <el-table
          stripe
          border
          ref="multipleTable2"
          highlight-current-row
          :data="hedgeLists"
          :row-key="(row) => row.guid"
          @row-click="hedgeListsChange"
          @select="handlehedgeSelectFlow"
          :header-cell-class-name="cellClass"
        >
          <el-table-column type="selection" :reserve-selection="true">
          </el-table-column>
          <!-- 流程名称 -->
          <el-table-column
            prop="flowName"
            min-width="120"
            label="流程名称"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.approveVO.flowName || "-" }}
            </template>
          </el-table-column>
          <!-- 发起人 -->
          <el-table-column
            prop="staffName"
            label="发起人"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.approveVO.staffName || "-" }}
            </template>
          </el-table-column>
          <!-- 药企名称 -->
          <el-table-column
            prop="bizTenantName"
            label="药企名称"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.serviceTenantName || "-" }}
            </template>
          </el-table-column>
          <!-- 组织名称 -->
          <el-table-column
            prop="organisationName"
            label="组织名称"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.organisationName || "-" }}
            </template>
          </el-table-column>
          <!-- 核算月 -->
          <el-table-column
            prop="accountMonthName"
            min-width="96"
            label="核算月"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
            <!-- <template slot-scope="scope">
                            {{ scope.row.accountMonth ? JSON.parse(scope.row.accountMonth).toString() :  '-'}}
                        </template> -->
          </el-table-column>
          <!-- 任务包名称 -->
          <el-table-column
            prop="taskTitleName"
            min-width="120"
            label="任务包名称"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.taskTitleName || "-" }}
            </template>
          </el-table-column>
          <!-- 已付款金额(元) -->
          <el-table-column
            prop="paidAmount"
            min-width="96"
            label="已付款金额(元)"
            header-align="center"
            align="right"
            show-overflow-tooltip
          >
            <template slot-scope="scope">{{
              scope.row.paidAmount | numFmt | numDigit
            }}</template>
          </el-table-column>
          <el-table-column
            prop="returnedAmount"
            min-width="96"
            label="已退回金额(元)"
            header-align="center"
            align="right"
            show-overflow-tooltip
          >
            <template slot-scope="scope">{{
              scope.row.returnedAmount | numFmt | numDigit
            }}</template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer">
        <el-button plain size="mini" @click="dialogHedgeVisible = false"
          >取消</el-button
        >
        <el-button size="mini" type="info" @click="selectHedgeProcess"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!-- end of dialog-关联金额对冲流程 -->

    <!-- start of dialog-批量修改对账日期 -->
    <el-dialog
      :title="'批量修改对账日期'"
      :visible.sync="dialogBatchEditTime"
      width="550px"
    >
      <div class="initiate-box">
        <div>对账日期：</div>
        <el-date-picker
          v-model="batchSettleDate"
          type="date"
          placeholder="选择对账日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </div>
      <div slot="footer">
        <el-button plain size="mini" @click="dialogBatchEditTime = false"
          >取消</el-button
        >
        <el-button size="mini" type="info" @click="batchEditTimeConfirm()"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!-- end of dialog-批量修改对账日期 -->
    <!-- 批量删除时选择人员弹框 -->
    <el-dialog
      title="选择部门/人员"
      :visible.sync="visible3"
      :close-on-click-modal="false"
      width="60%"
      center
      v-loading="tableLoading"
    >
      <div>
        <div class="select-box">
          <div class="box-left fl">
            <el-input
              v-model="filterText2"
              class="mt15"
              placeholder="请输入部门/人员名称"
            ></el-input>
            <el-tree
              class="filter-tree mt10"
              :data="areaData"
              :props="defaultProps"
              :show-checkbox="true"
              node-key="guid"
              :filter-node-method="filterNodeDep"
              @node-click="handleNodeClick1"
              ref="treeDep"
              @check-change="checkChange"
            >
              <div class="custom-tree-node" slot-scope="{ node, data }">
                <img
                  v-if="data.nodeType == 1"
                  src="@/assets/images/ico_ora.png"
                  alt=""
                />
                <img v-else src="@/assets/images/icon_per.png" alt="" />
                <span>{{ data.name }}</span>
              </div>
            </el-tree>
          </div>
          <div class="box-right fr">
            <p class="fontC-bbb fl">已选{{ departmentList.length }}人</p>
            <el-button
              size="mini"
              type="danger"
              @click="delDepartment()"
              class="fr"
              style="margin-top: 5px"
              >批量删除
            </el-button>
            <el-table
              :data="departmentList"
              border
              height="280px"
              style="width: 100%"
              @selection-change="handleSelectionChange1"
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                show-overflow-tooltip
                prop="name"
                label="名称"
              >
                <template slot-scope="scope">
                  {{ scope.row.name }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="mini" @click="visible3 = false">取消</el-button>
        <el-button size="mini" type="info" @click="submitDepartment()"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <ChoosePerson 
      ref="choosePerson"  
      :defaultTenantGuid="formData.serviceTenantGuid"
      :title="dialogTitle"
      :closeOnSelect="nodeList.length <= 1"
      staffType="2"
      @onSelect="onPersonSelect"
    >
    </ChoosePerson>
  </div>
</template>

<script>
import { bpmnroute } from "@/api/apiRoute";
import getTenantDetail from "../../mixins/getTenantDetail";
import { ServiceProviderTypeEnum } from "../../mixins/getTenantDetail";
import { BillCycleList } from "./enum.js";
import ChoosePerson from './components/choosePersonOne.vue';

export default {
  mixins: [getTenantDetail],
    components: {
    ChoosePerson,
  },
  data() {
    return {
      ServiceProviderTypeEnum,
      serviceTenantList: [],
      operateReportGuid: null,
      fullscreenLoading: false,
      trueOrFalseOption: [
        { text: "是", value: "Y" },
        { text: "否", value: "N" },
      ],
      isOption: [
        { text: "是", value: "Y" },
        { text: "否", value: "N" },
      ],
      billCycleListArr: BillCycleList,
      contractList: [],
      organisationDataList: [],
      taskList: [],

      formData: {
        settleDate: "", // 对账日期
        isStampApply: "", // 申请盖章
        accountMonth: "", // 核算月
        isSelectTask: "", // 是否选择任务包
        taskGuidList: [], // 任务包标题
        organisationGuid: "", // 接包组织
        billCycleList: [], // 账单周期
        contractGuid: "", // 关联合同
        qualityStateList: [], // 合格状态
        isShowServiceFee: "Y", // 是否展示服务费
        settleHedgeGuid: "", // 金额对冲流程guid
        relevanceHedge: "", // 金额对冲流程关联显示内容
        memo: "", // 备注
      },
      settlePaymentBankInfo: {}, // 下游结算流程企业收款银行信息
      settleReceiveBankInfo: [], // 收款方银行信息
      settleDetail: [], // 结算单明细
      immediateSubmit: false, // 保存时 草稿提交 false 提交审核 提交true
      tableData: [],

      selectData: [],
      batchSettleDate: "", // 批量修改的对账日期
      // 关联流程相关
      dialogHedgeVisible: false,
      dialogBatchEditTime: false,
      pageHedge: {
        pageIndex: 1,
        pageSize: -1,
        searchKey: "",
        isSettleUsed: "N",
        tenantGuid: localStorage.guid,
      },
      hedgeLists: [], // 对冲金额流程

      // 流程图相关
      iframeSh: false,
      iframeSrc: "",

      currentRow: "",
      currentHedgeRow: "",
      currentHedgeRowKey: null,
      settleReceiveBankInfo: [], //收款方信息
      visible3: false,
      tableLoading: false,
      filterText2: "",
      areaData: [],
      defaultProps: {
        id: "guid",
        label: "name",
        children: "children",
      },
      departmentList: [], //已选的人员
      delList: [], //删除人员的勾选
      personShow: false,
      nodeList: [],
      nodePersonList: [],
      dialogTitle: '选择人员',
    };
  },
  async created() {
    // await this.Mixins_getServiceProviderType();
    this.getServiceTenantList();
    this.getSettleReceiveBankList();
    this.getApprovalList();
  },
  watch: {
    filterText2(val) {
      this.$refs.treeDep.filter(val);
    },
  },
  computed: {
    serviceTenantName() {
      return (
        this.serviceTenantList.find(
          (item) => item.sendTenantGuid == this.formData.serviceTenantGuid
        )?.sendTenantName || ""
      );
    },
  },
  methods: {
    checkSearchData() {
      if (!this.formData.serviceTenantGuid) {
        this.$message.error("请选择上游服务商！");
        return;
      }
      if (!this.formData.settleDate) {
        this.$message.error("请选择对账日期！");
        return;
      }
      if (!this.formData.isStampApply) {
        this.$message.error("请选择是否申请盖章！");
        return;
      }

      if (!this.formData.accountMonth) {
        this.$message.error("请选择核算月！");
        return;
      }

      if (!this.formData.isSelectTask) {
        this.$message.error("请选择是否选择任务包！");
        return;
      }
      if (
        this.formData.isSelectTask == "Y" &&
        !this.formData.taskGuidList.length
      ) {
        this.$message.error("请选择任务包标题！");
        return;
      }
      if (
        this.formData.isSelectTask == "N" &&
        !this.formData.organisationGuid
      ) {
        this.$message.error("请选择接包组织！");
        return;
      }

      if (!this.formData.contractGuid) {
        this.$message.error("请选择合同！");
        return;
      }
      if (!this.formData.qualityStateList.length) {
        this.$message.error("请选合格状态！");
        return;
      }
      if (!this.formData.isShowServiceFee) {
        this.$message.error("请选择是否展示服务费！");
        return;
      }
      return true;
    },
    async searchData() {
      const f = this.checkSearchData();
      if (!f) return;

      // 获取单据明细
      this.fullscreenLoading = true;
      await this.getGgenerateDetail();
      this.fullscreenLoading = false;
    },
    changeAccountMonth() {
      this.formData.billCycleList = [];
      this.getCycleData();
    },
    changePrecise(val) {
      this.formData.billCycleList = [];
      this.formData.taskGuidList = [];
      this.formData.organisationGuid = "";
      if (val == "Y") {
        this.getTaskList();
        this.billCycleListArr = BillCycleList;
        return;
      }
      this.getCycleData();
      this.getOrganisationDataList();
    },
    //获取周期
    async getCycleData() {
      if (!this.formData.accountMonth) {
        return;
      }
      let accountMonth = JSON.parse(JSON.stringify(this.formData.accountMonth));
      accountMonth = accountMonth.replace("-", "");

      let tenantGuid = localStorage.guid;
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/staff-salary-task/data/get-salary-bill-cycle?accountMonth=${accountMonth}&tenantGuid=${tenantGuid}`
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.billCycleListArr = data?.data || [];
    },
    // 获取合同列表
    async getContractList() {
      let that = this;
      if (!that.formData.serviceTenantGuid) return;
      let tenantGuid = that.formData.serviceTenantGuid;
      const { data } = await that.api.get(
        `/${serverConfig.msCustomerService}/contract/get-child-tenant-all-contract?serviceTenantGuid=${localStorage.guid}&tenantGuid=${tenantGuid}`
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      that.contractList = data.data || [];

      that.contractList = that.contractList.map((item) => {
        const {
          contractName = "",
          isInsideDeduction = "N",
          signDate = "",
          chargeRate = "",
          contractCode = "",
        } = item;

        // 使用模板字符串拼接
        const text = [
          contractName,
          isInsideDeduction === "Y" ? "(内扣)_" : "",
          signDate ? `${signDate}_` : "",
          chargeRate ? `${chargeRate}%` : "",
          contractCode ? `_【${contractCode}】` : "",
        ]
          .filter(Boolean)
          .join("");

        return {
          ...item,
          text,
        };
      });
      if (that.contractList.length == 1) {
        this.formData.contractGuid = that.contractList[0].guid;
      }
    },
    changeDataOrganisation(val) {
      if (!val) {
        return;
      }

      const item = this.organisationDataList?.find((i) => i.guid === val);
      this.formData.organisationName = item?.organisationName;
    },
    changeTaskGuidList(val) {
      if (!val.length) {
        return;
      }
      if (!this.formData.accountMonth) {
        this.$message.error("请选择核算月！");
        this.formData.taskGuidList = [];
        return;
      }
    },
    delItem(row, idx) {
      this.$confirm("是否删除该条数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.tableData.splice(idx, 1);
      });
    },
    //获取服务商
    async getServiceTenantList() {
      let query = {
        tenantGuid: localStorage.guid,
      };
      const { data } = await this.api.get(
        `/${serverConfig.msCustomerService}/tenant/data/get-tenant-and-three-service`,
        query
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.serviceTenantList = data?.data || [];
    },
    async getOrganisationDataList() {
      const self = this;
      const query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: localStorage.guid,
        sendTenantGuid: localStorage.guid,
      };
      const { data } = await self.api.postJson(
        `/${serverConfig.msPersonnelService}/organisation/data/get`,
        query
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        self.$message.error(data.msg);
        return;
      }
      self.organisationDataList = data.data?.records || [];
    },
    tenantChange(val) {
      this.formData = {
        ...this.formData,
        billCycleList: "",
        taskGuidList: [],
        organisationGuid: "",
        contractGuid: "",
        isSelectTask: "",
      };
      this.getContractList();
    },
    //批量删除修改
    batchDel() {
      let self = this;
      self.filterText2 = "";
      self.visible3 = true;
      self.departmentList = [];
      self.delList = [];
      self.$nextTick(() => {
        self.$refs.treeDep.setCheckedNodes(self.departmentList);
      });
    },
    //获取组织
    getOrganisation() {
      let self = this;
      let staffGuidList = [
        ...new Set(this.tableData.map((item) => item.staffGuid)),
      ];
      let query = {
        tenantGuid: localStorage.guid,
        staffGuidList,
      };
      self.api
        .postJson(
          `/${serverConfig.msPersonnelService}/organisation/data/tree-staff-base`,
          query
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.areaData = res.data.data;
            self.batchDel();
          } else {
            self.$message.error(res.data.msg);
            self.areaData = [];
          }
          this.$forceUpdate();
        });
    },
    //获取任务
    async getTaskList() {
      let self = this;
      let query = {
        taskGuidList: self.formData.taskGuidList,
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: self.formData.serviceTenantGuid,
        organisationInfo: self.formData.organisationGuid,
        isService: "Y",
        payState: "未结算",
        state: ["已派发", "待上传", "待考核", "待结算"],
        accountMonth: self.formData.accountMonth,
        serviceTenantGuid: localStorage.guid,
        curTenantGuid: localStorage.guid,
        taskBelongCategory: 1,
      };
      query.accountMonth = query.accountMonth.replace("-", "");
      const { data } = await self.api.postJson(
        `/${serverConfig.msSalesPerformService}/task/data/get-list`,
        query
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        self.$message.error(data.msg);
        return;
      }
      self.taskList = data?.data.records || [];
    },
    getSumAmount(list, type) {
      let sum = 0;
      if (type == 1) {
        list.forEach((item) => {
          // sum += item.settleAmount;
          sum += Math.round(item.settleAmount * 100) / 100;
        });
      }
      if (type == 2) {
        list.forEach((item) => {
          // sum += item.realSettleMoney;
          sum += Math.round(item.realSettleMoney * 100) / 100;
        });
      }
      if (type == 3) {
        //实发
        list.forEach((item) => {
          sum += Math.round(item.actualSettleMoney * 100) / 100;
        });
      }
      return sum;
    },
    checkChange(val) {
      this.departmentList = [];
      let checkNodes = this.$refs.treeDep.getCheckedNodes();
      if (checkNodes.length > 0) {
        checkNodes.forEach((i) => {
          if (i.nodeType != 1) {
            this.departmentList.push(i);
          }
        });
      }
    },
    delDepartment() {
      let self = this;
      if (self.delList == null || self.delList.length == 0) {
        self.$message.error("请先勾选数据!");
        return;
      }
      self.delList.forEach(function (j) {
        self.departmentList.forEach(function (i, index) {
          if (i.guid == j.guid) {
            self.departmentList.splice(index, 1);
          }
        });
      });
      this.$refs.treeDep.setCheckedNodes(this.departmentList);
    },
    handleSelectionChange1(val) {
      let self = this;
      self.delList = val;
      console.log(val);
    },
    filterNodeDep(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    //部门弹框选择
    handleNodeClick1(data) {
      // let self = this;
      // console.log(data);
      // console.log(self.departmentList);
    },
    submitDepartment() {
      let self = this;
      if (!self.departmentList) {
        self.$message.error("请选择人员!");
        return;
      }
      let staffGuids = [];
      self.departmentList.forEach((i) => {
        staffGuids.push(i.guid);
        self.tableData = self.tableData.filter(
          (item) => !staffGuids.includes(item.staffGuid)
        );
      });
      self.visible3 = false;
      this.$forceUpdate();
    },
    cellClass(row) {
      if (row.columnIndex === 0) {
        return "disabledCheck";
      }
    },

    /**
     * 获得金额对冲流程
     */
    async showHedgeList() {
      if (this.hedgeLists.length == 0) {
        await this.getHedgeList();
        this.dialogHedgeVisible = true;
      }
      this.dialogHedgeVisible = true;
    },
    async getHedgeList() {
      let param = {
        ...this.pageHedge,
        flowTypeList: ["00025"],
        listType: 1,
        approveState: "Y",
        excludeOperateReportTenantGuid: this.currentRow.bizTenantGuid || "",
        excludeSettleLeveyGuids: this.excludeSettleLeveyGuids,
        staffGuid: JSON.parse(localStorage.userInfo).staffGuid,
        operateReportGuid: this.operateReportGuid,
      };
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/downstream/settle/hedge/page-list`,
        param
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.hedgeLists = data.data?.records || [];
      this.hedgeLists = this.hedgeLists.map((item) => {
        let accountMonth = JSON.parse(item?.accountMonth || "[]") || [];
        return {
          ...item,
          accountMonthName: accountMonth.join(","),
        };
      });
    },
    /**
     * 提交
     */
    submitForm() {
      if (!this.tableData.length) {
        this.$message.error("单据明细不能为空，不可提交！");
        return;
      }
      let length = this.nodeList.length;
      if (this.personShow && this.nodePersonList.length < length) {
        this.dialogTitle = '选择' + this.nodeList[this.nodePersonList.length] + '节点人员';
        this.$refs.choosePerson.visible = true;
        return;
      }
      this.postFormData();
    },
    async postFormData() {
      let f = this.checkSearchData();
      if (!f) return;
      f = this.checkForm();
      if (!f) return;
      let postData = JSON.parse(JSON.stringify(this.formData));
      let userInfo = JSON.parse(localStorage.userInfo);
      postData = {
        ...postData,
        accountMonth: postData.accountMonth.replace("-", ""),
        settleDetail: this.tableData,
        serviceTenantName: this.serviceTenantName,
        tenantGuid: localStorage.guid,
        tenantName: userInfo.tenantName,
        applyStaffGuid: userInfo.staffGuid,
        applyStaffName: userInfo.staffName,
        immediateSubmit: false, // false是保存 true是保存并提交 此页面只能保存 无法提交
        settleReceiveBankInfo: this.settleReceiveBankInfo,
        settleHedgeGuid: this.currentHedgeRowKey,
        startAssigner: this.nodePersonList?.[0] || '',
        startAssigners: this.nodePersonList?.length ? this.nodePersonList.slice(1) : null,
      };
      this.fullscreenLoading = true;
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/downstream/statement/add`,
        postData
      );
      this.fullscreenLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.$message.success("保存成功！");
      this.$router.go(-1);
    },
    checkForm() {
      if (!this.formData.serviceTenantGuid) {
        this.$message.error("上游服务商不能为空");
        return false;
      }
      if (!this.formData.settleDate) {
        this.$message.error("对账日期不能为空");
        return false;
      }
      if (!this.formData.isStampApply) {
        this.$message.error("盖章申请不能为空");
        return false;
      }
      try {
        // this.tableData.forEach((item) => {
        //   if (!item.levyCompanyGuid) {
        //     throw new Error("供应商不能为空，请批量调整");
        //   }
        // });
        this.settleReceiveBankInfo.forEach((item) => {
          if (!item.bankName) {
            throw new Error("请完善我方银行账号信息");
          }
        });
      } catch (e) {
        this.$message.error(e.message);
        return false;
      }

      return true;
    },
    /**
     * 批量修改对账日期
     */
    batchEditTime() {
      if (this.selectData.length == 0) {
        return this.$message.error("请先勾选数据");
      }
      this.dialogBatchEditTime = true;
      this.batchSettleDate = ""; // 批量修改的对账日期
    },
    /**
     * 批量修改对账日期确认
     */
    batchEditTimeConfirm() {
      let { selectData, tableData } = this;
      selectData.forEach((item) => {
        tableData.forEach((citem) => {
          if (item.rowKey == citem.rowKey) {
            citem.settleDate = this.batchSettleDate;
          }
        });
      });
      this.tableData = JSON.parse(JSON.stringify(tableData));
      this.dialogBatchEditTime = false;
    },
    /**
     * 勾选数据
     */
    handleSelectionChange(val) {
      console.log(val);
      this.selectData = val || [];
    },

    /**
     * 选择金额对冲流程
     */
    selectHedgeProcess() {
      let { currentHedgeRow } = this;
      let { approveVO } = currentHedgeRow;
      let paidAmount =
        currentHedgeRow.paidAmount !== null
          ? `${this.formatMoney(currentHedgeRow.paidAmount)}(元)`
          : "";
      let returnedAmount =
        currentHedgeRow.returnedAmount !== null
          ? `${this.formatMoney(currentHedgeRow.returnedAmount)}(元)`
          : "";
      // 关联流程后显示发起人 + 药企简称 + 月份 + 应付金额
      if (!approveVO["staffName"]) return this.$message.error("请关联流程");
      this.formData.relevanceHedge =
        approveVO["staffName"] +
        " _ " +
        currentHedgeRow["operationReportTenantName"] +
        " _ " +
        currentHedgeRow["accountMonthName"] +
        " _ " +
        paidAmount +
        returnedAmount;
      this.dialogHedgeVisible = false;
    },
    // 清空关联的金额对冲流程
    clearHedge() {
      this.currentHedgeRow = "";
      this.currentHedgeRowKey = "";
      this.formData.relevanceHedge = "";
      if (this.$refs.multipleTable2) this.$refs.multipleTable2.clearSelection();
    },
    /**
     * 获取单据明细
     */
    async getGgenerateDetail() {
      this.tableData = [];
      let userInfo = JSON.parse(localStorage.userInfo);
      if (!this.formData["settleDate"]) return;
      let postData = {
        ...this.formData,
        serviceTenantName: this.serviceTenantName,
        accountMonth: this.formData.accountMonth.replace("-", ""),
        tenantGuid: localStorage.guid,
        tenantName: userInfo.tenantName,
        applyStaffGuid: userInfo.userGuid,
        applyStaffName: userInfo.staffName,
        settleHedgeGuid: this.currentHedgeRow.guid,
      };
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/downstream/statement/generate-detail`,
        postData
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      let datas = data?.data || [];
      this.tableData = datas.map((item, index) => {
        return {
          ...item,
          rowKey: index,
          settleDate: this.formData.settleDate,
        };
      });
    },
    // 我方银行账号信息
    async getSettleReceiveBankList() {
      const req = {
        tenantGuids: [localStorage.guid],
      };
      const { data } = await this.api.postJson(
        `/${serverConfig.msCustomerService}/tenant/data/get-banks`,
        req
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      if (!data.data?.length) {
        return;
      }
      this.settleReceiveBankInfo = data.data.map((item) => {
        return {
          ...item,
          bankList: data.data[0]?.bankList || [],
          taxNo: item.taxpayerId,
          tenantGuid: localStorage.guid,
        };
      });
    },
    bankReciveChange(data) {
      console.log(data);
      let index = data.$index;
      let bankList = data.row.bankList;
      bankList.forEach((item) => {
        if (item.guid == data.row.bankGuid) {
          this.settleReceiveBankInfo[index].bankAccount = item.bankAccount;
          this.settleReceiveBankInfo[index].bankName = item.bankName;
        }
      });
    },

    /**
     * 清空条件搜索,重新获取流程列表数据
     */
    empty() {
      this.formData = {
        serviceTenantGuid: localStorage.guid,
      };
      this.clearHedge();
    },
    /**
     * 清空条件搜索,重新获取流程列表数据
     */
    emptyHedge() {
      this.pageHedge = {
        pageIndex: 1,
        pageSize: -1,
        pageHedge: "",
        searchKey: "",
        serviceTenantGuid: localStorage.guid,
      };
      this.clearHedge();
      this.gethedgeList();
    },
    /**
     * 关联流程，查看详情
     */
    see() {},
    /**
     * 勾选关联流程数据
     */
    hedgeListsChange(row) {
      this.$refs.multipleTable2.clearSelection();
      row.flag = !row.flag;
      this.$refs.multipleTable2.toggleRowSelection(row, row.flag);
      this.currentHedgeRowKey = row.guid;
      this.currentHedgeRow = row;
    },
    handlehedgeSelectFlow(selection, row) {
      this.$refs.multipleTable2.clearSelection();
      if (selection.length == 0) {
        return;
      }
      if (row) {
        this.currentHedgeRow = row;
        this.currentHedgeRowKey = row.guid;
        this.$refs.multipleTable2.toggleRowSelection(row, true);
      }
    },
    /**
     * 获取流程
     */
    getApprovalList() {
      // 00030 对账单流程
      let self = this;
      let userInfo = JSON.parse(localStorage.userInfo);
      let req = {
        tenantGuid: localStorage.guid,
        flowType: "00030",
        staffGuid: userInfo.staffGuid,
      };
      self.api
        .postJson(
          `/${serverConfig.msSalesPerformService}/work-flow/data/get-camunda-deployment-id`,
          req
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data) {
              self.iframeSrc =
                bpmnroute +
                "/iframeBpmn?camundaDeploymentId=" +
                res.data.data +
                "&token=" +
                localStorage.token;
              self.iframeSh = true;
              this.isLastPerson(res.data.data);
              this.getNodeList(res.data.data);
              this.$forceUpdate();
            } else {
              self.$message.error("未获取到流程信息");
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    isLastPerson(camundaDeploymentId) {
      let self = this;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/nodes/is-need-design?deploymentId=${camundaDeploymentId}`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.personShow = res.data.data;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getNodeList(camundaDeploymentId) {
      let self = this;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/get-assigners-process-name?deploymentId=${camundaDeploymentId}`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.nodeList = res.data.data || [];
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    onPersonSelect([personGuid, data]) {
      let person = personGuid.join(',');
      if (!person) {
        this.$message.error('请先选择人员!');
        return;
      }
      this.nodePersonList.push(person);
      this.submitForm();
    },

    formatMoney(num) {
      // 将数字转换为字符串并保留两位小数
      num = num.toFixed(2);

      // 将字符串按小数点分割成整数部分和小数部分
      let parts = num.toString().split(".");

      // 将整数部分每三位加一个逗号
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      // 将整数部分和小数部分拼接起来
      return parts.join(".");
    },
    // todo 展开表格扩展
    toggleRowAll() {
      this.settleReceiveBankInfo.forEach((row) => {
        this.$refs.multipleTable3.toggleRowExpansion(row, true); // 全部展开
      });
    },
  },
};
</script>

<style lang="less" scoped>
.select-with-search ::v-deep .el-select__tags {
  flex-wrap: nowrap !important;
  overflow: hidden !important;
  white-space: nowrap !important;
}

.select-with-search ::v-deep .el-select__input {
  flex-shrink: 1 !important;
  min-width: 80px !important;
}
.flex-between {
  display: flex;
  justify-content: space-between;
}

.total-tip {
  text-align: right;
  margin: 0 0 16px 0;
}

.total-tip span {
  color: #ff5f1f;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 10px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

::v-deep .el-table .disabledCheck .cell .el-checkbox__inner {
  display: none;
}

::v-deep .el-table .disabledCheck .cell::before {
  content: "";
  text-align: center;
  line-height: 37px;
}

.content {
  padding: 0px;
  margin: 0px;

  .title-box {
    border-top: 1px solid #e5e5e5;
    background-color: #ffffff;
    padding: 8px 0px;
    position: relative;

    button {
      font-size: 12px;
      color: #212121;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      padding: 0px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 2px;
      position: absolute;
      left: 16px;
      top: 6px;
    }

    span {
      text-align: center;
      font-size: 16px;
      font-weight: 400;
    }
  }

  .mt-4 {
    margin-top: 4px;
  }

  .pd-16 {
    padding-bottom: 16px;
  }

  .form-box {
    margin-top: 4px;
    text-align: left;

    .form-title {
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      margin-left: 16px;
      font-weight: 500;
    }

    /deep/ .el-row {
      margin: 0px !important;
    }

    .el-form-item {
      margin-bottom: 8px;
    }

    .over-label /deep/ .el-form-item__label {
      line-height: 21px;
    }

    .el-input {
      width: 220px;
    }

    .age-are-box {
      display: flex;
      align-items: center;

      .el-select {
        width: 142px;
      }

      span {
        margin: 0px 8px;
      }
    }

    .bottom-btn-box {
      padding: 18px 0px;
      text-align: center;
      border-top: 1px solid #e5e5e5;

      .el-button--primary {
        color: #ffffff;
      }
    }
  }

  /deep/ .el-dialog__header {
    text-align: left;
    border-bottom: 1px solid #d9d9d9;
  }

  /deep/ .el-dialog__body {
    padding: 0px 20px;
  }

  /deep/ .el-dialog__footer {
    padding: 10px 20px;
    border-top: 1px solid #d9d9d9;
  }

  .content-main-box2 {
    height: 55vh;
    overflow-x: hidden;

    .search-area {
      padding: 16px 0px;
    }

    .el-table {
      border-left: 1px solid #d8d8d8;
      border-right: 1px solid #d8d8d8;
      border-bottom: 1px solid #d8d8d8;
    }
  }

  .flow {
    background: #fff;
    padding-left: 20px;
  }

  .iframe-sty {
    width: 100%;
    border: none;
    height: 600px;
  }

  .detail-box {
    height: auto;
  }

  .cannel-btn {
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    color: #212121;
  }

  .initiate-box {
    display: flex;
    align-items: center;
    padding: 26px 0px;

    .el-select {
      margin-left: 10px;
    }
  }
  .table-expand {
    padding-left: 10px;
  }
}

// .content-main-box .el-table{
//     border: 0 none;
// }
.search-area .el-col-8 {
  justify-content: flex-start;
}
</style>
